(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-mp-carousel]').forEach((carousel) => {
      if (carousel.dataset.mpReady) return;
      carousel.dataset.mpReady = 'true';
      const rail = carousel.querySelector('[data-mp-rail]');
      let dragging = false;
      let dragged = false;
      let startX = 0;
      let startScroll = 0;
      let targetScroll = 0;
      let rafId = null;
      const applyScroll = () => {
        rafId = null;
        rail.scrollLeft = targetScroll;
      };
      rail.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        if (rail.scrollWidth <= rail.clientWidth + 1) return;
        dragging = true;
        dragged = false;
        startX = event.clientX;
        startScroll = rail.scrollLeft;
        targetScroll = startScroll;
        rail.classList.add('is-dragging');
        rail.setPointerCapture?.(event.pointerId);
      });
      rail.addEventListener('pointermove', (event) => {
        if (!dragging) return;
        const distance = event.clientX - startX;
        if (Math.abs(distance) > 5) dragged = true;
        targetScroll = startScroll - distance;
        if (rafId === null) rafId = requestAnimationFrame(applyScroll);
      });
      const stopDragging = (event) => {
        if (!dragging) return;
        dragging = false;
        if (rafId !== null) { cancelAnimationFrame(rafId); rafId = null; }
        rail.scrollLeft = targetScroll;
        rail.classList.remove('is-dragging');
        rail.releasePointerCapture?.(event.pointerId);
      };
      rail.addEventListener('pointerup', stopDragging);
      rail.addEventListener('pointercancel', stopDragging);
      rail.addEventListener('click', (event) => {
        if (!dragged) return;
        event.preventDefault();
        event.stopPropagation();
        dragged = false;
      }, true);
      carousel.querySelectorAll('[data-mp-arrow]').forEach((button) => {
        button.addEventListener('click', () => {
          const card = rail.firstElementChild;
          const step = card ? card.getBoundingClientRect().width + 18 : rail.clientWidth * .88;
          rail.scrollBy({ left: step * Number(button.dataset.mpArrow), behavior: 'smooth' });
        });
      });
    });
    root.querySelectorAll('[data-mp-accordion]').forEach((item) => {
      if (item.dataset.mpReady) return;
      item.dataset.mpReady = 'true';
      item.querySelector('button')?.addEventListener('click', () => {
        item.classList.toggle('is-open');
        item.querySelector('button').setAttribute('aria-expanded', item.classList.contains('is-open'));
      });
    });
  };
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
